"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMissingUserInfos = void 0;

var isMissingUserInfos = function isMissingUserInfos(user) {
  return user ? !user.first_name || !user.last_name : false;
};

exports.isMissingUserInfos = isMissingUserInfos;
//# sourceMappingURL=isMissingUserInfos.js.map